export default "__VITE_ASSET__a69df004__"